import { Characteristics } from "./Characteristics";
import { Advancement } from "./Dto/Advancement";

export type User = {
  id: string;
  name: string;
};

export type SpecialRule = {
  id: string;
  name: string;
};

export type Trait = {
  id: string;
  name: string;
  description: string;
};

export type Skill = {
  id: string;
  name: string;
  description: string;
};

export type TeamPreview = {
  id: string;
  name: string;
  faction: string;
  rating: number;
  creatorNickname: string;
  time: string;
};

export type WeaponUpgrade = {
  id: string;
  name: string;
  description: string;
  cost: number;
};

export type MyTeamPreview = {
  name: string;
  faction: string;
};

export type FighterInjury = {
  id: string;
  name: string;
  characteristicsMods: Characteristics;
};

export type LevelUp = {
  id: string;
  advancementDtos: Advancement[];
}

export type Advance = {
  id: string;
  name: string;
  characteristicsMods: Characteristics;
};

export type WeaponProfile = {
  id: string;
  weaponId: string;
  isDefault: boolean;
  cost: number;
  rarity: number;
  name: string | null;
  sr: string | null;
  lr: string | null;
  sm: string | null;
  lm: string | null;
  str: string | null;
  ap: string | null;
  d: string | null;
  am: string | null;
  traits: Trait[];
};

export type Weapon = {
  id: string;
  name: string;
  profiles: WeaponProfile[];
  upgrades: WeaponUpgrade[];
  cost: number;
  rarity: number | null;
  availibleOnTraidingPost: boolean;
};

export type Equipment = {
  id: string;
  name: string;
  rarity: number | null;
  cost: number;
};

export enum Status {
  ACTIVE = 1,
  ON_RECOVERY = 2,
  DEAD = 3,
}

export type FighterView = {
  id: string;
  name: string;
  rang: string;
  totalCharacteristics: Characteristics;
  weapons: Weapon[];
  equipment: Equipment[];
  skills: Skill[];
  status: Status;
  totalCost: number;
  xp: number;
  lvl: number;
};

export type Faction = {
  id: string;
  name: string;
  imageUrl: string;
  FactionEnum: number;
};

export type Territory = {
  id: string;
  name: string;
};
